import React, {FC} from "react"

import {WellnessMediaArticle} from "@irati/types"
import {FormattedMessage} from "@irati/utils/lang"

import {NotificationsEnabledStatusLabel} from "./styled"

interface Props {
  media: WellnessMediaArticle,
  wellnessNotificationIdsList: string[]
}

const LiveVideoCardLabelNotificationState: FC<Props> = ({media, wellnessNotificationIdsList}) => {
  const reminderEnabled = wellnessNotificationIdsList.includes(media.uuid)

  return (
    <NotificationsEnabledStatusLabel marginTop={2} reminderEnabled={reminderEnabled}>
      {reminderEnabled ? (
        <FormattedMessage id="platform.reminder.cta.reminderEnabled" />
      ) : (
        <FormattedMessage id="wellness.liveVideoCard.videoNotStarted.ctaText" />
      )}
    </NotificationsEnabledStatusLabel>
  )
}

export default LiveVideoCardLabelNotificationState
